import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authServices";
import { toast } from "react-toastify";

const getUserfromLocalStorage = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;
const initialState = {
  user: getUserfromLocalStorage,
  orders: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const login = createAsyncThunk(
  "auth/login",
  async (userData, thunkAPI) => {
    try {
      return await authService.login(userData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getOrders = createAsyncThunk(
  "order/get-orders",
  async (data, thunkAPI) => {
    try {
      return await authService.getOrders(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getaOrder = createAsyncThunk(
  "order/get-order",
  async (id, thunkAPI) => {
    try {
      return await authService.getOrder(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAOrder = createAsyncThunk(
  "order/update-order",
  async (data, thunkAPI) => {
    try {
      return await authService.updateOrder(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// New thunk for sending order confirmation email
export const sendOrderConfirmation = createAsyncThunk(
  "order/send-confirmation",
  async (data, thunkAPI) => {
    try {
      return await authService.sendOrderConfirmationEmail(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// New thunk for downloading invoice
export const downloadOrderInvoice = createAsyncThunk(
  "order/download-invoice",
  async (orderId, thunkAPI) => {
    try {
      return await authService.downloadInvoice(orderId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getMonthlyData = createAsyncThunk(
  "orders/monlthdata",
  async (data, thunkAPI) => {
    try {
      return await authService.getMonthlyOrders(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getYearlyData = createAsyncThunk(
  "orders/yearlydata",
  async (data, thunkAPI) => {
    try {
      return await authService.getYearlyStats(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {},
  extraReducers: (buildeer) => {
    buildeer
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.message = "success";
        if (state.isSuccess === true) {
          localStorage.setItem("user", JSON.stringify(action.payload));
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
        
        // Provide more user-friendly error messages
        const errorMsg = action.payload?.response?.data?.message || 
                        action.payload?.message || 
                        "An error occurred during login";
        
        // Handle specific error cases
        if (errorMsg.includes("Not Authorised")) {
          toast.error("You are not authorized to access the admin panel");
        } else if (errorMsg.includes("Invalid Credentials")) {
          toast.error("Invalid email or password");
        } else if (errorMsg.includes("Too many")) {
          toast.error("Too many login attempts. Please try again later");
        } else if (errorMsg.includes("blocked")) {
          toast.error("Your account has been blocked. Please contact support.");
        } else {
          toast.error(errorMsg);
        }
      })
      .addCase(getOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.orders = action.payload;
        state.message = "success";
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
        
        // Handle authentication errors
        if (action.payload?.response?.status === 401) {
          // Check if it's a session invalidation error
          if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Session invalidated")) {
            toast.error("Your session has been invalidated. Please log in again.");
          }
          // Check if it's a token expiration error
          else if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Access token expired")) {
            toast.error("Your session has expired. Please log in again.");
          } else {
            // User will be redirected to login by the service layer
            toast.error("Session expired. Please log in again.");
          }
        }
      })
      .addCase(updateAOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAOrder.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.message = "Order Updated Successfully";
      })
      .addCase(updateAOrder.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
      })
      .addCase(sendOrderConfirmation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendOrderConfirmation.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message || "Confirmation email sent successfully";
      })
      .addCase(sendOrderConfirmation.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message || "Failed to send confirmation email";
        state.isLoading = false;
      })
      .addCase(downloadOrderInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(downloadOrderInvoice.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.message = "Invoice downloaded successfully";
      })
      .addCase(downloadOrderInvoice.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message || "Failed to download invoice";
        state.isLoading = false;
      })
      .addCase(getaOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getaOrder.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.singleorder = action.payload;
        state.message = "success";
      })
      .addCase(getaOrder.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
        
        // Handle authentication errors
        if (action.payload?.response?.status === 401) {
          // Check if it's a session invalidation error
          if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Session invalidated")) {
            toast.error("Your session has been invalidated. Please log in again.");
          }
          // Check if it's a token expiration error
          else if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Access token expired")) {
            toast.error("Your session has expired. Please log in again.");
          } else {
            // User will be redirected to login by the service layer
            toast.error("Session expired. Please log in again.");
          }
        }
      })
      .addCase(getMonthlyData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMonthlyData.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.monthlyData = action.payload;
        state.message = "success";
      })
      .addCase(getMonthlyData.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
        
        // Handle authentication errors
        if (action.payload?.response?.status === 401) {
          // Check if it's a session invalidation error
          if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Session invalidated")) {
            toast.error("Your session has been invalidated. Please log in again.");
          }
          // Check if it's a token expiration error
          else if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Access token expired")) {
            toast.error("Your session has expired. Please log in again.");
          } else {
            // User will be redirected to login by the service layer
            toast.error("Session expired. Please log in again.");
          }
        }
      })
      .addCase(getYearlyData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getYearlyData.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.yearlyData = action.payload;
        state.message = "success";
      })
      .addCase(getYearlyData.rejected, (state, action) => {
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.isLoading = false;
        
        // Handle authentication errors
        if (action.payload?.response?.status === 401) {
          // Check if it's a session invalidation error
          if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Session invalidated")) {
            toast.error("Your session has been invalidated. Please log in again.");
          }
          // Check if it's a token expiration error
          else if (action.payload?.response?.data?.message && action.payload?.response?.data?.message.includes("Access token expired")) {
            toast.error("Your session has expired. Please log in again.");
          } else {
            // User will be redirected to login by the service layer
            toast.error("Session expired. Please log in again.");
          }
        }
      });
  },
});

export default authSlice.reducer;